/* import __COLOCATED_TEMPLATE__ from './html-preview-editor.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

const FONT_FAMILY_STYLE = '<style> body { font-family: "Source Sans Pro", sans-serif; } </style>'

export default class HtmlPreviewEditor extends Component {
  @tracked title = '';
  @tracked bodyText = '';

  get previewTitle() {
    return this.title ? `${this.title} - Preview` : `Preview`;
  }

  get iframeSource() {
    return "data:text/html;charset=utf-8," + encodeURI(FONT_FAMILY_STYLE + this.bodyText);
  }

  @action
  onBodyInput(value) {
    this.bodyText = value;
  }

  @action
  onTitleInput(value) {
    this.title = value;
  }
}
